import React from 'react';
import { Action, Modal } from '../aa';
import type { McpAuth } from '../../types/aai';

/*
 * The confirmation before an MCP server is removed, in the app rather than the
 * browser's own box, and saying only what is really deleted: a server with no
 * sign-in, or one never connected, has no token to lose.
 */
type Scope = 'mine' | 'company';

function whatGoes(scope: Scope, auth: McpAuth, connected: boolean): string {
  if (auth === 'none' || !connected) return 'It has no sign-in or token, so nothing else is deleted.';
  if (auth === 'oauth' && scope === 'mine') return 'Your sign-in to it is deleted. Adding it again means signing in again.';
  if (auth === 'oauth') return "The company's sign-in to it is deleted.";
  if (scope === 'mine') return 'The token or key you gave for it is deleted.';
  return "The company's token or key for it is deleted.";
}

export const RemoveMcpConfirm: React.FC<{
  scope: Scope;
  label: string;
  auth: McpAuth;
  connected: boolean;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}> = ({ scope, label, auth, connected, busy = false, onCancel, onConfirm }) => {
  let title = `Remove ${label}?`;
  let lead = 'It leaves your sessions.';
  let confirm = 'Remove';
  if (scope === 'company') {
    title = `Take ${label} out of the catalog?`;
    lead = "Nobody's sessions will have it.";
    confirm = 'Take it out';
  }
  return (
    <Modal
      size="dialog"
      context="MCP server"
      onClose={onCancel}
      footer={(
        <div className="flex justify-end gap-2">
          <Action variant="ghost" onClick={onCancel}>Cancel</Action>
          <Action variant="danger" onClick={onConfirm} disabled={busy} reason="Removing">{confirm}</Action>
        </div>
      )}
    >
      <h2 className="m-0 text-[22px] font-bold leading-[29px] tracking-[-0.015em] text-ink">{title}</h2>
      <p className="m-0 mt-2 text-[14px] leading-[23px] text-ink-muted">{lead} {whatGoes(scope, auth, connected)}</p>
    </Modal>
  );
};

export default RemoveMcpConfirm;
